export default defineNuxtRouteMiddleware((to, from) => {
  const params = to.params
  const query = to.query
  if (params.code === 'konkatsu_freepass') {
    return navigateTo({
      path: `/lp/konkatsu-freepass/?from_${import.meta.env.KONKATSU_FREEPASS_EVENT_CODE}`,
      query: query
    })
  }
  if (params.code === 'mens_pass') {
    return navigateTo({
      path: `/events/${import.meta.env.MENSPASS_EVENT_CODE}/`,
      query: query
    })
  }
  if (params.code === 'online_fitness_pass') {
    return navigateTo({
      path: `/events/${import.meta.env.ONLINE_FITNESS_PASS_EVENT_CODE}/`,
      query: query
    })
  }
  if (params.code === 'online_cafetalk_yoga_pass') {
    return navigateTo({
      path: `/events/${import.meta.env.ONLINE_CAFETALK_YOGA_PASS_EVENT_CODE}/`,
      query: query
    })
  }
})
